function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { Component } from 'react';
import compose from 'recompose/compose';
import defaultProps from 'recompose/defaultProps';
import pure from 'recompose/pure';
import withPropsOnChange from 'recompose/withPropsOnChange';
import setDisplayName from 'recompose/setDisplayName';
import { withTheme, withDimensions, getLabelGenerator, Container, SvgWrapper, bindDefs } from '@nivo/core';
import { getInheritedColorGenerator } from '@nivo/colors';
import { PieDefaultProps } from './props';
import PieSlice from './PieSlice';
import PieRadialLabels from './PieRadialLabels';
import PieSlicesLabels from './PieSlicesLabels';
import { PiePropTypes } from './props';
import PieLayout from './PieLayout';
import PieLegends from './PieLegends';

var Pie = function (_Component) {
    _inherits(Pie, _Component);

    function Pie() {
        _classCallCheck(this, Pie);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Pie.prototype.render = function render() {
        var _props = this.props,
            data = _props.data,
            sortByValue = _props.sortByValue,
            startAngle = _props.startAngle,
            endAngle = _props.endAngle,
            padAngle = _props.padAngle,
            fit = _props.fit,
            innerRadius = _props.innerRadius,
            cornerRadius = _props.cornerRadius,
            margin = _props.margin,
            width = _props.width,
            height = _props.height,
            outerWidth = _props.outerWidth,
            outerHeight = _props.outerHeight,
            colors = _props.colors,
            colorBy = _props.colorBy,
            borderWidth = _props.borderWidth,
            _borderColor = _props.borderColor,
            enableRadialLabels = _props.enableRadialLabels,
            getRadialLabel = _props.getRadialLabel,
            radialLabelsSkipAngle = _props.radialLabelsSkipAngle,
            radialLabelsLinkOffset = _props.radialLabelsLinkOffset,
            radialLabelsLinkDiagonalLength = _props.radialLabelsLinkDiagonalLength,
            radialLabelsLinkHorizontalLength = _props.radialLabelsLinkHorizontalLength,
            radialLabelsLinkStrokeWidth = _props.radialLabelsLinkStrokeWidth,
            radialLabelsTextXOffset = _props.radialLabelsTextXOffset,
            radialLabelsTextColor = _props.radialLabelsTextColor,
            radialLabelsLinkColor = _props.radialLabelsLinkColor,
            enableSlicesLabels = _props.enableSlicesLabels,
            getSliceLabel = _props.getSliceLabel,
            slicesLabelsSkipAngle = _props.slicesLabelsSkipAngle,
            slicesLabelsTextColor = _props.slicesLabelsTextColor,
            theme = _props.theme,
            defs = _props.defs,
            fill = _props.fill,
            isInteractive = _props.isInteractive,
            onClick = _props.onClick,
            onMouseEnter = _props.onMouseEnter,
            onMouseLeave = _props.onMouseLeave,
            tooltipFormat = _props.tooltipFormat,
            tooltip = _props.tooltip,
            legends = _props.legends;


        var borderColor = getInheritedColorGenerator(_borderColor, theme);

        return React.createElement(
            PieLayout,
            {
                width: width,
                height: height,
                data: data,
                sortByValue: sortByValue,
                startAngle: startAngle,
                endAngle: endAngle,
                fit: fit,
                padAngle: padAngle,
                innerRadius: innerRadius,
                cornerRadius: cornerRadius,
                colors: colors,
                colorBy: colorBy
            },
            function (_ref) {
                var centerX = _ref.centerX,
                    centerY = _ref.centerY,
                    radius = _ref.radius,
                    innerRadius = _ref.innerRadius,
                    arcs = _ref.arcs,
                    arcGenerator = _ref.arcGenerator;

                var boundDefs = bindDefs(defs, arcs, fill, {
                    dataKey: 'data'
                });

                return React.createElement(
                    Container,
                    { isInteractive: isInteractive, theme: theme, animate: false },
                    function (_ref2) {
                        var showTooltip = _ref2.showTooltip,
                            hideTooltip = _ref2.hideTooltip;
                        return React.createElement(
                            SvgWrapper,
                            {
                                width: outerWidth,
                                height: outerHeight,
                                margin: margin,
                                defs: boundDefs,
                                theme: theme
                            },
                            React.createElement(
                                'g',
                                { transform: 'translate(' + centerX + ',' + centerY + ')' },
                                arcs.map(function (arc) {
                                    return React.createElement(PieSlice, {
                                        key: arc.data.id,
                                        data: arc.data,
                                        path: arcGenerator(arc),
                                        color: arc.color,
                                        fill: arc.fill ? arc.fill : arc.color,
                                        borderWidth: borderWidth,
                                        borderColor: borderColor(arc),
                                        showTooltip: showTooltip,
                                        hideTooltip: hideTooltip,
                                        tooltipFormat: tooltipFormat,
                                        tooltip: tooltip,
                                        onClick: onClick,
                                        onMouseEnter: onMouseEnter,
                                        onMouseLeave: onMouseLeave,
                                        theme: theme
                                    });
                                }),
                                enableRadialLabels && React.createElement(PieRadialLabels, {
                                    arcs: arcs,
                                    radius: radius,
                                    label: getRadialLabel,
                                    skipAngle: radialLabelsSkipAngle,
                                    linkOffset: radialLabelsLinkOffset,
                                    linkDiagonalLength: radialLabelsLinkDiagonalLength,
                                    linkHorizontalLength: radialLabelsLinkHorizontalLength,
                                    linkStrokeWidth: radialLabelsLinkStrokeWidth,
                                    textXOffset: radialLabelsTextXOffset,
                                    textColor: getInheritedColorGenerator(radialLabelsTextColor, theme),
                                    linkColor: getInheritedColorGenerator(radialLabelsLinkColor, theme),
                                    theme: theme
                                }),
                                enableSlicesLabels && React.createElement(PieSlicesLabels, {
                                    arcs: arcs,
                                    radius: radius,
                                    innerRadius: innerRadius,
                                    theme: theme,
                                    label: getSliceLabel,
                                    skipAngle: slicesLabelsSkipAngle,
                                    textColor: getInheritedColorGenerator(slicesLabelsTextColor, theme)
                                })
                            ),
                            React.createElement(PieLegends, {
                                width: width,
                                height: height,
                                arcs: arcs,
                                legends: legends,
                                theme: theme
                            })
                        );
                    }
                );
            }
        );
    };

    return Pie;
}(Component);

Pie.propTypes = process.env.NODE_ENV !== "production" ? PiePropTypes : {};


var enhance = function enhance(Component) {
    return compose(defaultProps(PieDefaultProps), withTheme(), withDimensions(), withPropsOnChange(['radialLabel'], function (_ref3) {
        var radialLabel = _ref3.radialLabel;
        return {
            getRadialLabel: getLabelGenerator(radialLabel)
        };
    }), withPropsOnChange(['sliceLabel'], function (_ref4) {
        var sliceLabel = _ref4.sliceLabel;
        return {
            getSliceLabel: getLabelGenerator(sliceLabel)
        };
    }), pure)(Component);
};

export default setDisplayName('Pie')(enhance(Pie));